import { useState, useEffect } from 'react'
import { always, compose } from 'ramda'

/** (() -> Promise a) -> a -> UseState { isLoading: Bool, values: a } */
export const useFetcher = (fetch, initialValues) => {
  const [isLoading, setIsLoading] = useState(true)
  const [values, setValues] = useState(initialValues)
  const [errors, setErrors] = useState(undefined)

  useEffect(() => {
    setIsLoading(true)
    fetch()
      .then(
        compose(
          setErrors,
          always(undefined),
          setIsLoading,
          always(false),
          setValues,
          (data) => {
            return data
          },
        ),
      )
      .catch(compose(setIsLoading, always(false), setErrors))
  }, [fetch])

  return { isLoading, values, errors }
}
